import produce from 'immer';
import { getDaysAndOrder } from '@ers/middlewares/normalizer';
import { Message } from '@ers/data';
import { ActionTypes } from './Messages.actions';

export const initialState = {
    unreadThreadsCount: null,
    isLoadingThreads: true,
    threads: [],
    conversations: {
        isSending: false
    },
    fetchedAttachments: {}
};

const reducer = (state = initialState, action) => produce(state, (draft) => {
    switch (action.type) {
        case ActionTypes.fetchAllThreadsCompleted: {
            const { threads } = action.payload;
            draft.threads = threads;
            draft.isLoadingThreads = false;
            return draft;
        }
        case ActionTypes.fetchMessagesFromThreadCompleted: {
            const { days, datesOrder, messages, threadId } = action.payload;
            draft.conversations[threadId] = draft.conversations[threadId] || {
                draft: { body: '', attachments: [] },
                messages: [],
                days: {},
                datesOrder: []
            };

            draft.conversations[threadId].days = days;
            draft.conversations[threadId].datesOrder = datesOrder;
            draft.conversations[threadId].messages = messages;
            return draft;
        }
        case ActionTypes.markThreadAsRead: {
            const { threadId } = action.payload;
            draft.threads = state.threads.map((thread) => {
                if (thread.threadId === threadId) {
                    return {
                        ...thread,
                        isRead: true
                    };
                }
                return thread;
            });
            if (state.unreadThreadsCount) {
                draft.unreadThreadsCount = state.unreadThreadsCount - 1;
            }
            return draft;
        }
        case ActionTypes.messageEdited: {
            const { threadId, body } = action.payload;
            draft.conversations[threadId].draft.body = body;
            return draft;
        }
        case ActionTypes.addAttachments: {
            const { threadId, attachments } = action.payload;
            const currentAttachments = state.conversations[threadId].draft.attachments;
            draft.conversations[threadId].draft.attachments = currentAttachments.length ? attachments.extensions.merge(currentAttachments) : attachments;
            return draft;
        }
        case ActionTypes.removeAttachment: {
            const { threadId, index } = action.payload;
            draft.conversations[threadId].draft.attachments.splice(index, 1);
            return draft;
        }
        case ActionTypes.sendMessage: {
            const { threadId } = action.payload;
            draft.conversations[threadId].isSending = true;
            return draft;
        }
        case ActionTypes.sendMessageCompleted: {
            const { threadId } = action.payload;
            const message = new Message(state.conversations[threadId].draft);
            const { messages, datesOrder: _datesOrder } = state.conversations[threadId];
            const { days, datesOrder } = getDaysAndOrder([...messages, message.value], _datesOrder);
            draft.conversations[threadId].messages.push(message.value);
            draft.conversations[threadId].days = days;
            draft.conversations[threadId].datesOrder = datesOrder;
            draft.conversations[threadId].draft = { body: '', attachments: [] };
            draft.conversations[threadId].isSending = false;
            return draft;
        }
        case ActionTypes.fetchAttachmentCompleted: {
            const { threadId, fileId, file } = action.payload;
            draft.fetchedAttachments[threadId] = state.fetchedAttachments[threadId] || {};
            draft.fetchedAttachments[threadId][fileId] = file;
            return draft;
        }
        case ActionTypes.fetchThreadsUnreadCounterCompleted: {
            const { count } = action.payload;
            draft.unreadThreadsCount = count;
            return draft;
        }
        default: {
            return state;
        }
    }
});
export default reducer;
